import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  TituloPaginaModule,
  WbaTableModule,
  SearchInputAnimationModule,
  WInputModule,
  BlocoNovaVisaoModule,
  WbaSelectModule,
  WbaButtonModule,
  WbaSelect2Module,
  WbaOptionModule,
  WbaOptGroupModule,
  ContadorModule,
  MegaMenuModule,
  ChipsFiltroModule,
  MenuRightFiltroModule,
  CardTituloTextoModule,
  BoxInformacoesModule,
  MsgSemDadosModule,
  MsgFixaPaginaModule,
} from '@wbatd/design-system-wba';

import { MoedaRealMaskPipe } from '../../pipes/moeda-real-mask-pipe';
import { CpfCnpjMaskPipe } from '../../pipes/cpf-cnpj-mask-pipe';
import { FiltroEmpresaCedenteSacadoComponent } from 'src/app/components/filtro-empresa-cedente-sacado/filtro-empresa-cedente-sacado.component';

//material
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FiltroEmpresaInvestidorComponent } from 'src/app/components/filtro-empresa-investidor/filtro-empresa-investidor.component';
import { MatDialogModule } from '@angular/material/dialog';
import { OverlayModule } from '@angular/cdk/overlay';
import { LayoutModule } from '@angular/cdk/layout';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { FiltroEmpresaInvestidorModule } from 'src/app/components/filtro-empresa-investidor/filtro-empresa-investidor.module';

@NgModule({
  declarations: [MoedaRealMaskPipe, CpfCnpjMaskPipe, FiltroEmpresaCedenteSacadoComponent],
  imports: [
    CommonModule,
    TituloPaginaModule,
    WbaTableModule,
    SearchInputAnimationModule,
    WInputModule,
    BlocoNovaVisaoModule,
    WbaSelectModule,
    WbaButtonModule,
    WbaSelect2Module,
    WbaOptionModule,
    WbaOptGroupModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatDialogModule,
    LayoutModule,
    MatLegacyDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    ContadorModule,
    MegaMenuModule,
    MatSelectModule,
    ChipsFiltroModule,
    MenuRightFiltroModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    CardTituloTextoModule,
    MatStepperModule,
    BoxInformacoesModule,
    MsgSemDadosModule,
    MsgFixaPaginaModule,
    MatTooltipModule,
    OverlayModule,
    FiltroEmpresaInvestidorModule,
  ],
  exports: [
    FontAwesomeModule,
    TituloPaginaModule,
    WbaTableModule,
    SearchInputAnimationModule,
    WInputModule,
    BlocoNovaVisaoModule,
    WbaSelectModule,
    WbaButtonModule,
    WbaSelect2Module,
    WbaOptionModule,
    WbaOptGroupModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    ContadorModule,
    MegaMenuModule,
    MoedaRealMaskPipe,
    CpfCnpjMaskPipe,
    MatSelectModule,
    ChipsFiltroModule,
    MenuRightFiltroModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    CardTituloTextoModule,
    MatStepperModule,
    BoxInformacoesModule,
    MsgSemDadosModule,
    MsgFixaPaginaModule,
    MatTooltipModule,
    FiltroEmpresaCedenteSacadoComponent,
    FiltroEmpresaInvestidorModule,
  ],
})
export class SharedModule {}
